import React, { createContext } from 'react';
import { UserLogin } from '../types/ILogin';

interface AuthContextType {
  isAuthenticated: boolean;
  user: UserLogin;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  refreshLogin: () => void;
  loading: boolean; // Add this property
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export default AuthContext;
